import React, { useContext, useEffect, useState } from 'react';
import { CButton, CCard, CCardHeader, CCol, CRow, CModal, CModalHeader, CModalBody, CModalFooter } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import DownloadExcel from 'src/reusables/DownloadExcel';
import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';
import { getAll } from 'src/services/StockAdjustments';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';
import { AuthContext } from 'src/App';
function StockAdjustments() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');
  const navigate = useNavigate();
  const Auth = useContext(AuthContext);
  async function fetchMainData() {
    const res = await getAll();
    const rows =
      res.stockAdjustments &&
      res.stockAdjustments.map((item, i) => {
        return {
          no: i + 1,
          id: item.id,
          rqb: item.r_qty_before,
          rqa: item.r_qty_after,
          yqb: item.y_qty_before,
          yqa: item.y_qty_after,
          notes: item.notes,
          createdBy: item.createdBy,
          productName: item.productName,
          createdAt: formatter('dateOnly', item.created_at),
          diffRoll: item.diffRoll,
          diffYards: item.diffYards
        };
      });

    setDataRows(rows);

    const columns = [
      { field: 'no', headerName: 'No', width: '50' },
      { field: 'productName', headerName: 'Nama', width: '300' },
      { field: 'rqb', headerName: 'Stock Awal (Roll)', width: '150' },
      { field: 'rqa', headerName: 'Stock Akhir (Roll)', width: '150' },
      { field: 'yqb', headerName: 'Stock Awal (Yard)', width: '150' },
      { field: 'yqa', headerName: 'Stock Akhir (Yard)', width: '150' },
      { field: 'diffRoll', headerName: 'Selisih Roll', width: '150' },
      { field: 'diffYards', headerName: 'Selisih Yard', width: '150' },
      { field: 'notes', headerName: 'Catatan', width: '200' },
      { field: 'createdBy', headerName: 'Dibuat Oleh', width: '100' },
      { field: 'createdAt', headerName: 'Dibuat Pada', width: '150' }
    ];

    setDataColumns(columns);
  }

  useEffect(() => {
    fetchMainData();
  }, []);

  function handleRowClick(params) {
    navigate('/stock-adjustment-actions', { state: params.row });
  }

  return (
    <div style={{ color: 'black' }}>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />

      <CCard>
        <CCardHeader>
          <CRow className="mb-3">
            <CCol xs={7} lg={7}>
              <h4> Daftar Stock Adjustments </h4>
            </CCol>
            <CCol xs={5} lg={5} style={{ textAlign: 'right' }}>
              <CButton
                style={{ borderColor: 'primary' }}
                onClick={() => {
                  navigate('/stock-adjustment-actions');
                }}
              >
                Tambah
              </CButton>
              &nbsp;
              {/* {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
                <DownloadExcel
                  rows={dataRows}
                  columns={dataColumns}
                  excelName="Daftar Produk"
                  config={{ width: '20' }}
                />
              )} */}
              <DownloadExcel rows={dataRows} columns={dataColumns} excelName="Daftar Produk" config={{ width: '20' }} />
            </CCol>
          </CRow>
        </CCardHeader>
        <div style={{ margin: '16px' }}>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: 'center' }}
          />
        </div>
      </CCard>
    </div>
  );
}

export default StockAdjustments;
